import '.cr{font-size:1.125rem;}.ssr-plugin'
import '.f6{line-height:1.75rem;}.ssr-plugin'
import '.c1{text-decoration:none;}.ssr-plugin'
import '.eu{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cr f6"
    >
      {translations.privacySubtitle}{' '}
      <a className="c1 eu"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="c1 eu"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
